import apiClient from '@/lib/api-client';

export interface AdminUser {
  id: number;
  username: string;
  role: 'ADMIN' | 'USER';
  active: boolean;
  validTill: string;
  modules?: any[]; // The API doesn't show modules in the GET response, but it might have them
}

export type Lifecycle = 'AUDIT' | 'TRIAL' | 'WEEKLY' | 'EXTENDED';

export interface CreateUserRequest {
  username: string;
  password: string;
  modules: { moduleId: number }[];
  lifecycle: Lifecycle;
}

export const userService = {
  getAllUsers: async (): Promise<AdminUser[]> => {
    const response = await apiClient.get('/admin/users');
    return response.data.data || [];
  },

  createUserWithModule: async (userData: CreateUserRequest): Promise<any> => {
    const response = await apiClient.post('/admin/create-user-with-module', userData);
    return response.data;
  },

  // We'll keep these as placeholders or check if they exist later
  async deleteUser(username: string): Promise<any> {
    const response = await apiClient.delete(`/admin/delete-user/${username}`);
    return response.data;
  },

  async updatePassword(username: string, password: string): Promise<any> {
    const response = await apiClient.put('/admin/update-password', { username, password });
    return response.data;
  },

  async updatePermissions(username: string, modules: { moduleId: number }[]): Promise<any> {
    const response = await apiClient.put('/admin/update-permissions', { username, modules });
    return response.data;
  },

  async activateUser(username: string): Promise<any> {
    const res = await apiClient.put(`/admin/activate/${username}`);
    return res.data;
  },

  async deactivateUser(username: string): Promise<any> {
    const res = await apiClient.put(`/admin/deactivate/${username}`);
    return res.data;
  },

  async extendUserValidity(username: string, lifecycle: Lifecycle): Promise<any> {
    const response = await apiClient.put('/admin/extend-validity', { username, lifecycle });
    return response.data;
  },

  async updateUser(payload: { username: string; newPassword?: string; modules?: string[] }): Promise<any> {
    const response = await apiClient.put('/admin/update-user', payload);
    return response.data;
  },

  async getUserModules(): Promise<any> {
    const response = await apiClient.get('/user/modules');
    return response.data;
  }
};
